import { useNavigate } from "react-router-dom";
import SecondaryButton from "./SecondaryButton";

export default function TopBar({ showBack, title }) {
  const navigate = useNavigate();
  return (
    <div className="w-full max-w-md mx-auto flex items-center justify-between">
      <div className="w-20">
        {showBack ? <SecondaryButton onClick={() => navigate(-1)}>← Back</SecondaryButton> : null}
      </div>
      <div className="text-sm text-gray-600">{title}</div>
      <div className="w-20" />
    </div>
  );
}
